import React, {
  RefObject,
} from 'react';
import {
  VirtualTableInstance,
} from 'core/components/VirtualTable/types';
import Table from 'core/components/VirtualTable';
import {
  LedgerRow,
} from 'pages/Dashboard/pages/Ledger/types';
import columns from 'pages/Dashboard/pages/Ledger/columns';

type Props = {
  tableInstanceRef: RefObject<VirtualTableInstance>;
  ledgers: LedgerRow[];
};

export default function Overview({
  tableInstanceRef,
  ledgers,
}: Props) {
  return (
    <div className="relative flex min-h-[240px] flex-1 flex-col overflow-y-hidden">
      <Table<LedgerRow>
        instanceRef={tableInstanceRef as RefObject<VirtualTableInstance>}
        data={ledgers}
        getRowId={({ encounterId, id }, idx) => encounterId ?? id ?? idx}
        getSubRows={({ transactionLogs }) => transactionLogs ?? []}
        getRowCanExpand={({ original: { expandable } }) => expandable ?? false}
        columns={columns}
        classes={{
          header: '!py-0.5 px-4 !items-end',
          outerColumn: '!items-start',
          column: '!text-left',
          scrollContainer: 'justify-center items-center',
          outerRow: '!w-[calc(100%-16px)] left-4',
          row: '!items-stretch !pt-1',
          cell: '!items-start !h-auto',
          subRow: '!pb-1 !border-t !border-gray-200',
        }}
        loadingSlot="Loading transactions..."
      />
    </div>
  );
}
